import axios from 'axios';

import { headers, salesServiceUrl } from '../../config';

export function getItems(params) {
    return axios.get(`${salesServiceUrl}/items`, { headers: headers(), params })
}